import styled from 'styled-components'

export const Container = styled.section`
  padding: 80px 0;
  background-color: ${(props) => props.theme.azulEscuro};
  width: 100%;
  overflow: hidden;

  /* Estilização das classes internas do Swiper */
  .swiper {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: 300px; /* Define um tamanho fixo para o Swiper calcular o layout */
    display: flex;
    justify-content: center;
    transition: opacity 0.3s ease;
  }
  .swiper-slide:not(.swiper-slide-active) {
    opacity: 0.4;
  }
`

export const TituloSecao = styled.h2`
  text-align: center;
  color: ${(props) => props.theme.azulMuitoClaro};
  font-size: 36px;
  margin-bottom: 50px;
`

export const CardAula = styled.div`
  background-color: ${(props) => props.theme.azulPrincipal};
  border: 1px solid ${(props) => props.theme.azulDestaque};
  border-radius: 20px;
  padding: 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  img {
    width: 100%;
    height: 200px;
    object-fit: contain;
    margin-bottom: 20px;
  }

  h3 {
    color: ${(props) => props.theme.brancoFrio};
    margin-bottom: 15px;
  }

  button {
    background-color: ${(props) => props.theme.azulAcentuado};
    color: #fff;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
    transition: 0.3s;

    &:hover {
      filter: brightness(1.2);
    }
  }
`
